import React, { Component } from 'react'
import { postAddressSearch, postValidateAddress } from '../../services/vu'
import ConfirmationModal from './ConfirmationModal'
import AddressValidationStatus from '../../enums/AddressValidationStatus'
import { Autocomplete, TextField } from '@mui/material'

export default class AddressValidator extends Component {
  constructor(props) {
    super(props)

    this.state = {
      searchText: '',
      confidenceLevel: '',
      suggestions: [],
      preventClose: false,
      addressNotFoundError: false,
      isDropdownFocused: false,
      currentValidatedAddress: null,
      isModalOpen: false,
      selectedAddress: null,
    }
  }

  componentDidUpdate(prevProps, nextProps) {
    if ((prevProps.country !== this.props.country) || (prevProps.disabled !== this.props.disabled)) {
      this.setState({
        searchText: '',
        isModalOpen: false
      })
    }
  }

  searchSuggestions = (address) => {
    const cleanedAddress = address.trim().replace(/\s+/g, ' ');
    const nonSpaceLength = cleanedAddress.replace(/\s/g, '').length;

    if (nonSpaceLength > 4) {
      const countryCode = this.props.country === 'ENG' ? 'GBR' : this.props.country;

      postAddressSearch(countryCode, cleanedAddress)
        .then((result) => {
          this.setState({
            confidenceLevel: result.confidence,
            suggestions: result.suggestions || [],
            addressNotFoundError: false,
          });
        })
        .catch(() => {
          this.setState({
            suggestions: [],
            addressNotFoundError: true,
          });
        });
    } else {
      this.setState({ suggestions: [] });
    }
  }

  normalizeAddress = (address) => address.replace(/\s+/g, " ").trim();

  getAddressDetails = (address) => this.state.suggestions.filter(
    (suggestion) => this.containsAddress(suggestion.address.toLowerCase(), address.toLowerCase())
  );

  containsAddress = (str, text) =>  new RegExp(text).test(str);

  handleRequest = (event ,chosenAddress) => {
    const { currentAddress, currentValidationStatus, name, handleAddressValidation } = this.props
    const countryCode = this.props.country === 'ENG' ? 'GBR' : this.props.country

    this.setState({ preventClose: true, searchText: chosenAddress?.address || "", selectedAddress: chosenAddress}, () => {
      if(chosenAddress){
        const isSameAddress = currentAddress.length && this.containsAddress(chosenAddress.address, currentAddress)
        if (!isSameAddress || (isSameAddress && currentValidationStatus.validationStatus !== AddressValidationStatus.VALIDATED)) {
          postValidateAddress(chosenAddress.globalAddressKey, countryCode).then(result => {
            handleAddressValidation(result, name)
            setTimeout(() => {
              this.setState({ preventClose: false, currentValidatedAddress: result, addressNotFoundError: false })
            }, 100)
          })
        }
      } else {
        this.setState({suggestions : []})
      }
    })
  }

  handleClose = () => {
    setTimeout(() => {
      const { preventClose, searchText, currentValidatedAddress } = this.state;
      const matchedSuggestions = this.getAddressDetails(searchText) || [];
  
      if (preventClose || matchedSuggestions.length === 1) {
        if (
          matchedSuggestions.length &&
          searchText !== matchedSuggestions[0]?.address &&
          (!currentValidatedAddress || currentValidatedAddress.globalAddressKey !== matchedSuggestions[0]?.globalAddressKey)
        ) {
          this.setState({ isModalOpen: true, addressNotFoundError: false });
        } else {
          this.setState({ addressNotFoundError: false });
        }
      } else {
        this.setState({
          addressNotFoundError: (!matchedSuggestions.length || matchedSuggestions.length > 1) && searchText.length ? true : false
        })
      }
    }, 0);
  };
  
  handleCloseModal = () => this.setState({isModalOpen: false, searchText: '', suggestions: []})

  handleConfirmation = () => {
    const { suggestions } = this.state

    this.handleRequest(null, suggestions[0])
    this.setState({ isModalOpen: false, searchText: suggestions[0].address })
  }

  handleInputChange = (event, newInputValue, reason) => {
    // Allow editing after selection
    if (reason !== 'reset') {
      this.setState({ 
        searchText: newInputValue,
        selectedAddress: null // Clear selection when editing
      }, () => {
        if (newInputValue.trim().length > 0) {
          this.searchSuggestions(newInputValue);
        }
      });
    }
  };

  customFilterOptions = (options, { inputValue }) => {
    const normalize = (str) =>
      (str || '')
        .toLowerCase()
        .replace(/[^a-z0-9\s/]/gi, ' ') // keep slash initially
        .replace(/\//g, ' ')           // convert slashes to space
        .replace(/\s+/g, ' ')          // normalize multiple spaces
        .trim();

    const normalizedSearch = normalize(inputValue);
    const searchTerms = normalizedSearch.split(' ');

    return options.filter((option) => {
      const normalizedAddress = normalize(option.address);
      const result = searchTerms.every((term) => normalizedAddress.includes(term));
      return result;
    });
  };

  render() {
    const { isModalOpen, suggestions, addressNotFoundError, searchText, selectedAddress} = this.state;

    return (
      <div>
        <Autocomplete
          name={this.props.name}
          filterOptions={this.customFilterOptions}
          options={this.state.suggestions}
          getOptionLabel={(option) => option.address || ""}
          isOptionEqualToValue={(option, value) => 
            option?.globalAddressKey === value?.globalAddressKey
          }
          onClose={this.handleClose}
          onInputChange={this.handleInputChange}
          onChange={this.handleRequest}
          inputValue={searchText}
          value={selectedAddress}
          disabled={this.props.disabled}
          renderInput={(params) => {
            params.InputProps.endAdornment = undefined;
            params.inputProps.readOnly = this.props.disabled;
            return (
              <TextField
                {...params}
                error={addressNotFoundError}
                helperText={addressNotFoundError ? 'Unable to verify the address provided' : false}
                label="Find Address"
                variant="standard"
                fullWidth={true}
                margin="normal"
                sx={{ margin: 0 }}
              />
            );
          }}
        />

        <ConfirmationModal 
          isOpen={isModalOpen}
          title="Address Confirmation"
          handleCloseModal={this.handleCloseModal}
          handleCancel={this.handleCloseModal}
          handleConfirmation={this.handleConfirmation}
        >
          {suggestions.length ? (
            <div className='center my-20'>
              <p> 
                Would you like to update your address for the following address?
              </p>
              <p><b>{suggestions[0].address}</b></p>
            </div>
          ) : null}
        </ConfirmationModal>
      </div>
      

    )
  }
}